@if (report$ | async; as report) {
  <ng-container *rmaLet="isReportOwner$ as isReportOwner">
    @if (report.profile.bannerImage) {
      <div
        class="flex h-14 w-full items-center justify-center"
        [style.backgroundColor]="report.profile.backgroundColour"
        [class]="{ 'bg-steel-100': !report.profile.backgroundColour }"
      >
        <img rmaBrokenImage class="max-h-14" [src]="report.profile.bannerImage" [alt]="report.profile.agencyName" />
      </div>
    }
    @if ((isPrintMode$ | async) === false && !isReportOwner && report.trixelImgUrl) {
      <rma-trixel [trixelImgUrl]="report.trixelImgUrl" [trixelSourceCategory]="trixelCategory" />
    }
    <div class="mr-container mx-4 flex max-w-7xl flex-col gap-8 md:mx-auto print:block">
      <rma-market-report-header class="print:hidden" [report]="report" />
      <rma-market-report-property
        [isPrintMode]="isPrintMode$ | async"
        [propertyDetails]="report.propertyDetails"
        [mapMarker]="primaryMapMarker$ | async"
        [printedUrl]="report.printedPropertyMapUrl"
      />
      <rma-market-report-print-header class="hidden print:block" [report]="report" />
      <section class="mr-container flex break-before-page flex-col gap-8 print:block">
        @if (report.statistics.length && report.propertyDetails.includeAgentStatistics) {
          <rma-market-report-statistics
            class="break-inside-avoid print:mb-8"
            [statistics]="report.statistics"
            [name]="report.profile.fullName"
          />
        }
        @if (report.rankings.length) {
          <rma-market-report-rankings class="break-inside-avoid print:mb-8" [rankings]="report.rankings" />
        }
        @if (report.agencyStatistics.length && report.propertyDetails.includeAgencyStatistics) {
          <rma-market-report-statistics
            class="break-inside-avoid print:mb-8"
            [statistics]="report.agencyStatistics"
            [name]="report.profile.agencyName ?? report.profile.fullName"
          />
        }
        @if (report.agencyRankings.length) {
          <rma-market-report-rankings class="break-inside-avoid print:mb-8" [rankings]="report.agencyRankings" />
        }
        @if (report.agentBadges || report.agentAwards || report.agencyAwards) {
          <rma-market-report-recognition
            class="break-inside-avoid print:mb-8"
            [awards]="report.agentAwards ?? report.agencyAwards ?? []"
            [badges]="report.agentBadges"
          />
        }
      </section>
      @if (report.comparableCampaigns.length) {
        <rma-market-report-comparable-properties
          class="break-before-page print:mt-8"
          [comparableCampaigns]="report.comparableCampaigns"
          [primaryMapMarker]="primaryMapMarker$ | async"
          [isPrintMode]="isPrintMode$ | async"
          [printedUrl]="report.printedComparablePropertiesMapUrl"
        />
      }
      @if (report.reviews.length) {
        <rma-market-report-reviews
          class="break-before-page print:mt-8"
          [reviews]="report.reviews"
          [isReportOwner]="isReportOwner"
          [primaryMapMarker]="primaryMapMarker$ | async"
          [isPrintMode]="isPrintMode$ | async"
          [printedUrl]="report.printedReviewsMapsUrl"
        />
      }
    </div>
    <rma-market-report-footer
      class="mt-8 bg-steel-10 print:hidden"
      [class.pb-16]="isReportOwner"
      [profile]="report.profile"
      [awards]="report.agentAwards ?? report.agencyAwards"
    />
    @if (isReportOwner && (isAuthorised$ | async) === false) {
      <nav class="border-t-gray-300 fixed bottom-0 left-0 grid w-full grid-cols-12 items-center gap-4 bg-white p-4">
        <a
          class="col-span-12 mb-4 md:col-span-4 md:mb-0 md:ml-4 lg:col-span-3"
          href="/dashboard/billing/free-trial?tier=Professional&subscribeIntention=MarketReport"
          mat-flat-button
          color="accent"
          data-id="start-trial"
        >
          <span>{{ 'button.label.upgrade' | transloco }}</span>
        </a>
      </nav>
    } @else {
      @if (isReportOwner) {
        <rma-market-report-publish class="print:hidden" [report]="report" />
      }
    }
  </ng-container>
}
